import React, { useEffect, useMemo, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";

const PPDCompletedInvoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const snap = await getDocs(collection(db, "invoices")); // ✅ change if needed
        const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setInvoices(rows);
      } catch (e) {
        console.error("PPDCompletedInvoices fetch error:", e);
      }
    };
    fetchInvoices();
  }, []);

  const normalize = (v) => (v || "").toString().toLowerCase();

  const filtered = useMemo(() => {
    const term = normalize(search);

    return invoices.filter((inv) => {
      const s = normalize(inv.status || inv.invoiceStatus || inv.state);

      const isCompleted =
        s === "completed" ||
        s === "complete" ||
        s === "invoice completed" ||
        s.includes("completed");

      if (!isCompleted) return false;

      if (!term) return true;

      return (
        normalize(inv.wo).includes(term) ||
        normalize(inv.siteName).includes(term) ||
        normalize(inv.customerName).includes(term) ||
        normalize(inv.client).includes(term) ||
        normalize(inv.address).includes(term) ||
        normalize(inv.city).includes(term) ||
        normalize(inv.email).includes(term)
      );
    });
  }, [invoices, search]);

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>PPD Completed Invoices</h2>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 10 }}>
        <input
          type="text"
          placeholder="Search invoices…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ minWidth: 260 }}
        />
        <div style={{ fontWeight: 700, opacity: 0.8 }}>Results: {filtered.length}</div>
      </div>

      {filtered.length === 0 ? (
        <p style={{ opacity: 0.8 }}>No completed invoices found.</p>
      ) : (
        <ul style={{ paddingLeft: 18 }}>
          {filtered.map((inv) => (
            <li key={inv.id} style={{ marginBottom: 10 }}>
              <strong>WO:</strong> {inv.wo || "—"}{" "}
              <strong>Site:</strong> {inv.siteName || inv.customerName || "—"}{" "}
              <strong>Total:</strong> {inv.total || inv.amount || "—"}{" "}
              <strong>Status:</strong> {inv.status || inv.invoiceStatus || "Completed"}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PPDCompletedInvoices;
